<template>
    <div class="box">
        <Header></Header>
      <!--项目介绍-->
        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '煤炭贸易' : 'Coal Trade'}}</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?text:textEng}}</p>
                <img style="width: 100%;height: auto;margin-top: 20px;" :src="path" alt="">

                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top:35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '境外物流' : 'Overseas Logistics'}}</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textAbroad:textAbroadEng}}</p>
                <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathAbroad" alt="">

                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top:35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '境内物流' : 'Domestic logistics'}}</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textTerritory:textTerritoryEng}}</p>
                <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathTerritory" alt="">

                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top:35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '仓储服务' : 'Warehousing Services'}}</p>
                <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textStorage:textStorageEng}}</p>
                <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathStorage" alt="">
            </div>
          <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'CoalTrade',
	components: {
		Header, Footer
	},
	data () {
		return {
            typefaces: 1,
            typeFacesNumber: 0,
            banner: {},
            text: '',
            textEng: '',
            path: '',
            textTerritory: '',
            textTerritoryEng: '',
            pathTerritory: '',
            textAbroad: '',
            textAbroadEng: '',
            pathAbroad: '',
            textStorage: '',
            textStorageEng: '',
            pathStorage: ''
		}
	},
  computed: {
    aaa() {
      return this.$root.TYPEFACE;
    }
  },
  watch:{
    aaa(type) {
      this.typefaces = type;
    },
  },

	mounted() {
    this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
    this.getData();
    this.getList();
    this.getTerritoryList();
    this.getAbroadList();
    this.getStorageList();
	},

	methods: {
    fatherMethod(type){
      this.typefaces = type;
      this.typeFacesNumber = type;
    },
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 13
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		},

        // 获取煤炭贸易
		getList() {
			axios({
				url: this.url + '/content/introduce/list?type=0',
				method: 'get',
				data: {
				},
			}).then( res => {
                this.text = res.data.rows[0].text;
                this.textEng = res.data.rows[0].textEng;
                this.path = res.data.rows[1].path;
			});
		},
    // 获取境外物流
    getAbroadList() {
      axios({
        url: this.url + '/content/introduce/list?type=1',
        method: 'get',
        data: {
        },
      }).then( res => {
        this.textAbroad = res.data.rows[0].text;
        this.textAbroadEng = res.data.rows[0].textEng;
        this.pathAbroad = res.data.rows[1].path;
      });
    },
    // 获取境内物流
    getTerritoryList() {
      axios({
        url: this.url + '/content/introduce/list?type=2',
        method: 'get',
        data: {
        },
      }).then( res => {
        this.textTerritory = res.data.rows[0].text;
        this.textTerritoryEng = res.data.rows[0].textEng;
        this.pathTerritory = res.data.rows[1].path;
      });
    },
    // 获取仓储服务
    getStorageList() {
      axios({
        url: this.url + '/content/introduce/list?type=3',
        method: 'get',
        data: {
        },
      }).then( res => {
        this.textStorage = res.data.rows[0].text;
        this.textStorageEng = res.data.rows[0].textEng;
        this.pathStorage = res.data.rows[1].path;
      });
    }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/ProjectIntroduction/coalTrade.vue